<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>
  <div #line class="line" [style.top]="lineY"></div>
  <ion-list lines="none" class="menu">
    <ion-item button disabled><div translate>MENU.COREFACTS.NAME</div></ion-item>
    <ion-item button [disabled]="brand['MAIN'] == 'none'" (click)="showCompanyPage('MAIN')" *ngIf="showMenuEntry('MENU.COREFACTS.MAIN')"><div translate>MENU.COREFACTS.MAIN</div></ion-item>
    <ion-item button [disabled]="brand['INFO'] == 'none'" class="second-level" (click)="showCompanyPage('INFO')" *ngIf="showMenuEntry('MENU.COREFACTS.INFO')"><div translate>MENU.COREFACTS.INFO</div></ion-item> 
    <ion-item button [disabled]="brand['MATERIAL'] == 'none'" class="second-level" (click)="showCompanyPage('MATERIAL')" *ngIf="showMenuEntry('MENU.COREFACTS.MATERIAL')"><div translate>MENU.COREFACTS.MATERIAL</div></ion-item> 
    <ion-item button [disabled]="brand['CONTACT'] == 'none'" class="second-level" (click)="showCompanyPage('CONTACT')" *ngIf="showMenuEntry('MENU.COREFACTS.CONTACT')"><div translate>MENU.COREFACTS.CONTACT</div></ion-item> 
</ion-list>

</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>